export default __webpack_public_path__ + "static/media/default_bg.7d639c53.png";